module.exports = __webpack_public_path__ + "static/media/printer.05ae9d3e.svg";